import { useDispatch } from 'react-redux'
import { useEffect } from 'react'
import { convertToRealError, noop } from 'utils'
import { getErrorMessage } from 'features/ErrorMessages'
import { useUpdatingRef } from 'utils/hooks/useUpdatingRef'
import { Toasts } from '../../features/toast/toastSlice'

export const useErrorToast = ({
  error,
  handleClearError = noop,
  defaultMessage,
  messageMap,
}) => {
  const handleClearErrorRef = useUpdatingRef(handleClearError)
  const dispatch = useDispatch()

  useEffect(() => {
    if (!error) return
    if (process.env.NODE_ENV === 'development') {
      console.error(convertToRealError(error))
    }
    const message = getErrorMessage(error, {
      defaultMessage,
      messageMap,
    })
    dispatch(Toasts.fail(message))
    handleClearErrorRef.current(dispatch)
  }, [error, dispatch, handleClearErrorRef, defaultMessage, messageMap])
}
